import { useIsFocused } from '@react-navigation/native';

import { useIsLoggedIn } from '@order/AuthMachine';
import { useGiftCardBalanceQuery } from '@order/graphql';
import { useFeatureFlag } from '@order/LaunchDarkly';
import { useLocalizationContext } from '@order/Localization';

// ─────────────────────────────────────────────────────────────────────────────

export const useGiftCardBalance = () => {
  const { formatPrice } = useLocalizationContext();

  const isLoggedIn = useIsLoggedIn();
  const isScreenFocused = useIsFocused();
  const shouldSeparatePromoAndGiftCard = useFeatureFlag(
    'CELS-1410-separate-promo-and-gift-card',
  );

  // ─────────────────────────────────────────────────────────────────────

  const [{ data, fetching: isFetching }] = useGiftCardBalanceQuery({
    requestPolicy: 'cache-and-network',
    pause: !isLoggedIn || !isScreenFocused || !shouldSeparatePromoAndGiftCard,
  });

  const giftCardBalanceData = data?.giftCardBalance;
  const giftCardBalance =
    giftCardBalanceData?.__typename === 'GiftCardBalance'
      ? giftCardBalanceData.giftCardBalance
      : 0;
  const giftCardBalanceFormatted = formatPrice(giftCardBalance, 'USD');

  // ─────────────────────────────────────────────────────────────────────

  return { balance: giftCardBalanceFormatted, isFetching };
};
